import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError } from "@/contexts/AuthContext";

const PRESETS = [["shorten", "Shorten"], ["punch_up", "Punch up"], ["fix_grammar", "Fix grammar"], ["friendlier", "Friendlier"], ["formal", "More formal"]];

export function AiAssist({ text, kind, onResult }) {
  const [busy, setBusy] = useState(null);
  const [custom, setCustom] = useState("");
  const run = async (instruction) => {
    if (!(text || "").trim()) { toast.error("Write something first"); return; }
    setBusy(instruction);
    try { const { data } = await api.post("/email-campaigns/ai-edit", { text, instruction, kind }); onResult(data.text); setCustom(""); toast.success("Updated by AI — undo by editing the text"); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); } finally { setBusy(null); }
  };
  return (
    <div className="border border-dashed border-[#D4AF37]/60 rounded-sm p-2 bg-[#FFFDF5]" data-testid="ai-assist">
      <div className="flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] font-bold text-[#0B132B] mb-1.5"><Sparkles size={11} className="text-[#D4AF37]" /> AI assist</div>
      <div className="flex flex-wrap gap-1 mb-1.5">{PRESETS.map(([k, l]) => (
        <button key={k} type="button" disabled={!!busy} onClick={() => run(k)} className="px-2 py-1 text-[11px] rounded-sm border border-[#E9ECEF] bg-white hover:border-[#D4AF37] text-[#0B132B] disabled:opacity-50 flex items-center gap-1" data-testid={`ai-assist-${k}`}>{busy === k && <Loader2 size={10} className="animate-spin" />}{l}</button>
      ))}</div>
      <form onSubmit={(e) => { e.preventDefault(); if (custom.trim()) run(custom.trim()); }} className="flex gap-1">
        <Input value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Or tell it what to change…" className="rounded-sm h-8 text-xs" data-testid="ai-assist-custom" />
        <button type="submit" disabled={!!busy || !custom.trim()} className="px-2.5 h-8 text-[11px] font-bold rounded-sm bg-[#0B132B] text-white disabled:opacity-50" data-testid="ai-assist-custom-run">{busy && !PRESETS.some(([k]) => k === busy) ? <Loader2 size={10} className="animate-spin" /> : "Go"}</button>
      </form>
    </div>
  );
}
